











import {GOOGLE_MAPS_API_KEY} from '@/shared/configuration';
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class GoogleStreetView extends Vue {
    @Prop({required: true, type: Number})
    public readonly longitude: number;

    @Prop({required: true, type: Number})
    public readonly latitude: number;

    protected get url(): string {
        const params = new URLSearchParams({
            location: `${this.latitude},${this.longitude}`,
            key: GOOGLE_MAPS_API_KEY,
            source: 'outdoor',
        });
        return `https://www.google.com/maps/embed/v1/streetview?${params.toString()}`;
    }

    public mounted() {
    }
}
